import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineStar } from "react-icons/ai";
import { useParams } from "react-router";
import { Pagination } from "swiper";
import { Swiper } from "swiper/react";
import CardProduct from "../../components/CardProduct";
import { LoaderSmall } from "../../components/Loader";
import Title from "../../components/Title";
import UIInfiniteScroll from "../../components/UI/InfiniteScroll/InfiniteScroll";
import notify from "../../components/UI/toast";
import { useUserData } from "../../hooks/UserContext";
import api from "../../_services/api";
import { Empty } from "./_components/empty";
import { PageWrap } from "./styles";
import "swiper/css";
import "swiper/css/pagination";
import { clientesApi } from "../OrderResumePag/_services/api";
import { produtosApi } from "../OrderResumePag/_services/api";

export default function Favorites() {
  const [acceptNextPage, setAcceptNextPage] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [newPage, setNewPage] = useState(0);
  const [limit] = useState(process.env.REACT_APP_DEFAULT_LIMIT_PAGE);
  const [order] = useState("price_desc");
  const { desc } = useParams();

  const jwt = useUserData();
  const dataUser = jwt.userData?.data;
  const cpf = dataUser?.cpf;

  const handleProductRemoved = (productUuid) => {
    setProducts((prevProducts) => prevProducts.filter(p => p.uuid !== productUuid));
  };

  function loadParams() {
    return {
      q: desc,
      page: newPage,
      limit,
      order: { order },
    };
  }

  async function apiProducts( uuids ) {
    const uuidParams = uuids.map(uuid => `uuids[]=${uuid}`).join('&');
    const response = await produtosApi.get(
      `/v1/products/search?partner_customer_id=${cpf}&${uuidParams}`,
      { params: loadParams() }
    );
    return response.data;
  }

  async function apiWishlist() {
    if (!cpf) {
      return { data: [], total_items: 0 };
    }
    
    try {
      const response = await clientesApi.get(
        `/customer/wishlist`,
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return { data: [], total_items: 0 };
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (newPage === 0) setLoading(true);
      setLoadingProducts(true);
      
      if (typeof cpf !== "undefined") {
        try {
          const response = await apiWishlist();
          
          if (!response.data || response.data.length === 0) {
            if (newPage === 0) {
              setProducts([]);
            }
            setAcceptNextPage(false);
            setLoadingProducts(false);
            setLoading(false);
            return;
          }

          const productsResponse = await apiProducts(response.data.map((item) => item.product_uuid));
          
          const pageCount = Math.trunc(response.total_items / limit);

          if (newPage === 0) {
            setProducts(productsResponse.data || []);
          } else {
            setProducts((prevProducts) => {
              const existingUuids = new Set(prevProducts.map(p => p.uuid));
              const newProducts = (productsResponse.data || []).filter(p => !existingUuids.has(p.uuid));
              return [...prevProducts, ...newProducts];
            });
          }

          if (newPage >= pageCount) {
            setAcceptNextPage(false);
          } else {
            setAcceptNextPage(true);
          }
          
          setLoadingProducts(false);
          setLoading(false);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log("erros", err);
          if (newPage === 0) {
            setProducts([]);
          }
          setAcceptNextPage(false);
          setLoadingProducts(false);
          setLoading(false);
          notify("Erro ao buscar produtos", "error");
        }
      }
    };
    
    fetchData();
    // eslint-disable-next-line
  }, [newPage, cpf]);

  function fetchMore() {
    setNewPage((prevPage) => prevPage + 1);
  }

  if (loading) return <LoaderSmall />;

  if (!loading && !products.length) {
    return (
      <Container className="pt-4 h-100">
        <div className="wl-page h-100">
          <Title label="Favoritos">
            <AiOutlineStar />
          </Title>
          <Empty />
        </div>
      </Container>
    );
  }

  return (
    <PageWrap>
    <Container className="pt-4">
      <div className="wl-page">
        <Title label="Favoritos">
          <AiOutlineStar />
        </Title>
        <Swiper
          slidesPerView={2}
          breakpoints={{
            568: { slidesPerView: 4 },
          }}
          spaceBetween={12}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          <>
            <Row className="mt-4 product-grid">
              {products?.map((product) => {
                const { uuid, label } = product;
                const priceFormatted = {
                  BRL: {
                    offer: product?.product_price?.price ?? 0,
                    price: product?.product_price?.price_suggested !== product?.product_price?.price ? product.product_price.price_suggested : null
                  },
                  points: {
                    // A API traz o valor do produto como points_suggested, e o desconto como points.
                    offer: Math.round(product?.product_price?.points_suggested) ?? 0,
                    price: product?.product_price?.points !== product?.product_price?.points_suggested
                             ? Math.round(product.product_price.points)
                             : null,
                  },
                };
                return (
                  <Col xs={6} key={uuid} className="pb-4">
                    <CardProduct
                      id={uuid}
                      label={label}
                      image={product.images[0]?.path}
                      price={priceFormatted}
                      campaign=""
                      wishlist={true}
                      cashback=""
                      searchColorButton={false}
                      onWishlistRemoved={handleProductRemoved}
                    />
                  </Col>
                );
              })}
              {products &&
                acceptNextPage && (
                  <UIInfiniteScroll fetchMore={fetchMore} />
                )}
            </Row>
          </>
        </Swiper>
        
        {loadingProducts && (
          <div className="text-center mb-5">
            <span className="spinner-border color-wl" role="status" />
          </div>
        )}
      </div>
    </Container>
    </PageWrap>
  );
}